const data = {};

class B2bEvent {
  static set(key, value) {
    data[key] = value;
  }
  static get(key) {
    return data[key];
  }
}

export default B2bEvent;
